import script from "./navDrawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./navDrawer.vue?vue&type=script&lang=ts&setup=true"

import "./navDrawer.vue?vue&type=style&index=0&id=133cfc5a&scoped=true&lang=css"

import exportComponent from "/builds/psj7085139/sam/samva-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-133cfc5a"]])

export default __exports__